import { IWfaSessionIssue } from 'src/apps/wfa/services/WfaDashboardServiceTypes';

const CSV_LIST_SEPARATOR = ', ';

export const mapWfaIssuesToCsvRows = (rows: IWfaSessionIssue[]): string[][] =>
	rows.map(
		({
			id,
			detectionTime,
			crossScansId,
			firstTimeSeen,
			type,
			severity,
			wcagTags,
			summary,
			description,
			knowledgeBaseUrl,
			knowledgeBaseLinks,
			componentIds,
			components,
			selectors,
			htmlSnippets,
			url,
			pageTitle,
			note
		}) => [
			id,
			detectionTime,
			crossScansId,
			firstTimeSeen,
			type,
			severity,
			wcagTags.join(CSV_LIST_SEPARATOR),
			summary,
			description,
			knowledgeBaseUrl,
			knowledgeBaseLinks.join(CSV_LIST_SEPARATOR),
			componentIds.join(CSV_LIST_SEPARATOR),
			components.join(CSV_LIST_SEPARATOR),
			selectors.join(CSV_LIST_SEPARATOR),
			htmlSnippets.join(CSV_LIST_SEPARATOR),
			url,
			pageTitle,
			note
		]
	);
